import { render, staticRenderFns } from "./ChooseMultipleProductInput.vue?vue&type=template&id=4990421e&scoped=true"
import script from "./ChooseMultipleProductInput.vue?vue&type=script&lang=js"
export * from "./ChooseMultipleProductInput.vue?vue&type=script&lang=js"
import style0 from "./ChooseMultipleProductInput.vue?vue&type=style&index=0&id=4990421e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4990421e",
  null
  
)

export default component.exports